import { render, staticRenderFns } from "./moneyBackYx.vue?vue&type=template&id=122d119b"
import script from "./moneyBackYx.vue?vue&type=script&lang=js"
export * from "./moneyBackYx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports